var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"content"},[_vm._t("content",function(){return [_c('SpinnerLoader')]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }